var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBatchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 9.16667H4.16667M15.8333 9.16667C16.7538 9.16667 17.5 9.91286 17.5 10.8333V15.8333C17.5 16.7538 16.7538 17.5 15.8333 17.5H4.16667C3.24619 17.5 2.5 16.7538 2.5 15.8333V10.8333C2.5 9.91286 3.24619 9.16667 4.16667 9.16667M15.8333 9.16667V7.5C15.8333 6.57953 15.0871 5.83333 14.1667 5.83333M4.16667 9.16667V7.5C4.16667 6.57953 4.91286 5.83333 5.83333 5.83333M5.83333 5.83333V4.16667C5.83333 3.24619 6.57953 2.5 7.5 2.5H12.5C13.4205 2.5 14.1667 3.24619 14.1667 4.16667V5.83333M5.83333 5.83333H14.1667",
    stroke: "#535964",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatchIcon);
export default __webpack_public_path__ + "static/media/BatchIcon.b5ee254dd57c2eddd275cb1462d68528.svg";
export { ForwardRef as ReactComponent };